// extracted by mini-css-extract-plugin
export default {"close-button":"AIZrzn","closeButton":"AIZrzn","closeButtonImage":"C2Qds2","dark":"QWIKQX"};